// eslint-disable-next-line
export default {
    // Auth
    "auth.login": "Logowanie",
    "auth.email": "Email",
    "auth.password": "Hasło",
    "auth.enterEmail": "Wprowadź swój email",
    "auth.enterPassword": "Wprowadź hasło",
    "auth.loginButton": "Zaloguj się",
    "auth.loggingIn": "Logowanie...",
    "auth.loginTitle": "Zaloguj się do systemu",
    "auth.loginDescription": "Wprowadź swój email i hasło, aby się zalogować",
    "auth.logout": "Wyloguj się",
    "auth.authError": "Błąd autoryzacji",

    // Common
    "common.loading": "Ładowanie...",
    "common.save": "Zapisz",
    "common.cancel": "Anuluj",
    "common.delete": "Usuń",
    "common.edit": "Edytuj",
    "common.create": "Utwórz",
    "common.close": "Zamknij",
    "common.confirm": "Potwierdź",
    "common.yes": "Tak",
    "common.no": "Nie",
    "common.search": "Szukaj",
    "common.filter": "Filtr",
    "common.settings": "Ustawienia",
    "common.active": "Aktywny",
    "common.inactive": "Nieaktywny",
    "common.blocked": "Zablokowany",
    "common.total": "Razem",
    "common.deleteUser": "Usuń użytkownika",
    "common.resetPassword": "Resetuj hasło",
    "common.confirmDelete": "Potwierdź usunięcie",
    "common.deleteConfirmText": "Czy na pewno chcesz usunąć tego użytkownika? Tej akcji nie można cofnąć.",

    // Roles
    "role.admin": "Administrator",
    "role.teacher": "Nauczyciel",
    "role.student": "Uczeń",

    // Navigation
    "nav.dashboard": "Panel kontrolny",
    "nav.users": "Użytkownicy",
    "nav.students": "Uczniowie",
    "nav.teachers": "Nauczyciele",
    "nav.courses": "Kursy",
    "nav.schedule": "Harmonogram",
    "nav.grades": "Oceny",
    "nav.last_entry": "Ostatnie logowanie",
    "nav.visits": "Wizyty",
    "nav.never": "Nigdy",

    // Admin Dashboard
    "admin.title": "Panel administratora",
    "admin.createTeacher": "Utwórz nauczyciela",
    "admin.systemUsers": "Użytkownicy systemu",
    "admin.userManagement": "Zarządzanie wszystkimi użytkownikami systemu",
    "admin.stats.admins": "Admini",
    "admin.stats.teachers": "Nauczyciele",
    "admin.stats.students": "Uczniowie",
    "admin.block": "Zablokuj",
    "admin.unblock": "Odblokuj",

    // Teacher Dashboard
    "teacher.title": "Panel nauczyciela",
    "teacher.inviteStudent": "Zaproś ucznia",
    "teacher.myStudents": "Moi uczniowie",
    "teacher.studentManagement": "Zarządzanie uczniomi w twoich grupach",
    "teacher.noStudents": "Nie masz jeszcze żadnych uczniow",
    "teacher.inviteFirst": "Zaproś swojego pierwszego ucznia, klikając przycisk powyżej",
    "teacher.addedOn": "Dodano:",

    // Student Dashboard
    "student.title": "Panel ucznia",
    "student.personalInfo": "Informacje osobiste",
    "student.yourData": "Twoje dane w systemie",
    "student.fullName": "Imię i nazwisko",
    "student.role": "Rola",
    "student.status": "Status",
    "student.courses": "Kursy",
    "student.coursesDesc": "Moje kursy i materiały",
    "student.schedule": "Harmonogram",
    "student.scheduleDesc": "Harmonogram zajęć",
    "student.grades": "Oceny",
    "student.gradesDesc": "Moje oceny i osiągnięcia",
    "student.notifications": "Powiadomienia",
    "student.updates": "Najnowsze aktualizacje i ogłoszenia",
    "student.welcome": "Witamy w systemie!",
    "student.welcomeDesc":
        "Zostałeś pomyślnie zarejestrowany w systemie zarządzania szkołą. Tutaj możesz przeglądać swoje kursy, harmonogram i oceny.",
    "student.today": "Dzisiaj",
    "student.featuresInDev": "Funkcje w rozwoju",
    "student.featuresDesc":
        "Dodatkowe funkcje dla studentów (kursy, zadania, oceny) zostaną dodane w przyszłych wersjach systemu.",
    "student.info": "Informacja",

    // Password Change
    "password.change": "Zmień hasło",
    "password.new": "Nowe hasło",
    "password.confirm": "Potwierdź hasło",
    "password.required": "Musisz zmienić hasło tymczasowe, aby kontynuować",
    "password.enter": "Wprowadź nowe hasło dla swojego konta",
    "password.minLength": "Minimum 6 znaków",
    "password.repeat": "Powtórz nowe hasło",
    "password.saving": "Zapisywanie...",
    "password.success": "Hasło zostało pomyślnie zmienione",
    "password.error": "Błąd podczas zmiany hasła",
    "password.minError": "Hasło musi zawierać co najmniej 6 znaków",
    "password.mismatch": "Hasła nie pasują do siebie",

    // Create Teacher Modal
    "createTeacher.title": "Utwórz nauczyciela",
    "createTeacher.description": "Wprowadź dane nowego nauczyciela. Zaproszenie zostanie wysłane na podany email.",
    "createTeacher.fullName": "Imię i nazwisko",
    "createTeacher.fullNamePlaceholder": "Jan Kowalski",
    "createTeacher.emailPlaceholder": "teacher@school.pl",
    "createTeacher.creating": "Tworzenie...",
    "createTeacher.success": "Nauczyciel został utworzony pomyślnie",
    "createTeacher.error": "Błąd podczas tworzenia nauczyciela",
    "createTeacher.exists": "Użytkownik z tym emailem już istnieje",

    // Invite Student Modal
    "inviteStudent.title": "Zaproś studenta",
    "inviteStudent.description": "Wprowadź dane nowego studenta. Zaproszenie zostanie wysłane na podany email.",
    "inviteStudent.fullName": "Imię i nazwisko",
    "inviteStudent.fullNamePlaceholder": "Anna Nowak",
    "inviteStudent.emailPlaceholder": "student@school.pl",
    "inviteStudent.sending": "Wysyłanie zaproszenia...",
    "inviteStudent.success": "Student został zaproszony pomyślnie",
    "inviteStudent.error": "Błąd podczas zapraszania studenta",

    // System
    "system.title": "System edukacji odległej",
    "system.error": "Błąd systemu",
    "system.networkError": "Błąd sieci",
    "system.unauthorized": "Nieautoryzowany dostęp",
    "system.forbidden": "Dostęp zabroniony",
    "system.notFound": "Nie znaleziono",
    // Trainers

    "messages.userDeleted": "Użytkownik został pomyślnie usunięty",
    "messages.passwordReset": "Hasło zostało zresetowane i wysłane na email",
    "messages.deleteError": "Błąd podczas usuwania użytkownika",
    "messages.resetError": "Błąd podczas resetowania hasła",

    "training.start": "Rozpocznij trening",
    "trainings.title": "Moduły treningowe",
    "trainings.memory": "Trening pamięci",
    "trainings.memory.description": "Ćwiczenia treningowe pamięci dla studentów",
    "trainings.logic": "Zagadki logiczne",
    "trainings.logic.description": "Zagadki logiczne i zadania dla studentów",
    "trainings.back": "Powrót",
    "trainig.notImplemented": "Ten moduł treningowy nie jest jeszcze zaimplementowany",
    // Mental arithmetics
    "trainings.mental": "Arytmetyka mentalna",
    "trainings.mental.description": "Trening arytmetyki mentalnej dla studentów",

    "mentalArithmetic": "Arytmetyka Mentalna",
    "trainer": "Trener",
    "flashCards": "Karty Flash",
    "additionSubtraction": "Dodawanie / Odejmowanie",
    "multiplicationDivision": "Mnożenie / Dzielenie",
    "selectTrainerSettings": "Wybierz ustawienia trenera",
    "selectCardsSettings": "Wybierz ustawienia kart flash",
    "selectMultiSettings": "Wybierz ustawienia trenera",
    "go": "Idź",
    "theme": "Temat",
    "difficulty": "Trudność",
    "digits": "Cyfry",
    "actionsCount": "Liczba działań",
    "inputTime": "Czas na wprowadzenie",
    "speed": "Prędkość",
    "start": "Start",
    "stop": "Stop",
    "settings": "Ustawienia",
    "continue": "Kontynuuj",
    "simple": "Proste",
    "brother": "Brat",
    "friend": "Przyjaciel",
    "friendBrother": "Przyjaciel + Brat",
    "transitions": "Przejścia",
    "allThemes": "Wszystkie tematy",
    "multiplication": "Mnożenie",
    "division": "Dzielenie",
    "squaring": "Podnoszenie do kwadratu",
    "performExercise": "Wykonaj ćwiczenie",
    "yourAnswer": "Twoja odpowiedź:",
    "correct": "Poprawnie",
    "incorrect": "Niepoprawnie",
    "answer": "Odpowiedź",
    "sec": "sek",
    "multiplier": "Mnożnik",
    "divisor": "Dzielnik",
    "any": "Dowolny",
    "multiplicationTable": "Tabliczka mnożenia",
    "byMultiplicationTable": "Według tabliczki mnożenia",
    "resetAllSettings": "Zresetować wszystkie ustawienia i przeładować stronę?",
    "difficulties": {
        "0-4": "0-4",
        "0-5": "0-5",
        "0-6": "0-6",
        "0-7": "0-7",
        "0-8": "0-8",
        "0-9": "0-9",
        "4": "4",
        "3": "3",
        "2": "2",
        "1": "1",
        "9": "9",
        "8": "8",
        "7": "7",
        "6": "6",
        "5": "5",
        "50Plus": "50 +",
        "50Minus": "50 -",
        "100Plus": "100 +",
        "100Minus": "100 -"
    },
    "multiDifficulties": {
        "multiplicationTable": "Tabliczka mnożenia",
        "2x1": "II x I",
        "3x1": "III x I",
        "2x2": "II x II",
        "4x1": "IIII x I",
        "3x2": "III x II",
        "base50": "Baza 50",
        "base100": "Baza 100",
        "base200": "Baza 200",
        "byMultiplicationTable": "Według tabliczki mnożenia",
        "2div1": "II / I",
        "3div1": "III / I",
        "4div1": "IIII / I",
        "2div2": "II / II",
        "3div2": "III / II",
        "4div2": "IIII / II",
        "4div3": "IIII / III",
        "2-10": "2-10",
        "on5": "przez 5",
        "11-19": "11-19",
        "20-30": "20-30",
        "30-70": "30-70",
        "80-120": "80-120"
    },
    "multiThemes": {
        "multiplication": "Mnożenie",
        "division": "Dzielenie",
        "squaring": "Podnoszenie do kwadratu"
    },
    "cardsDifficulties": {
        "0-4": "0-4",
        "0-9": "0-9"
    }
}